import React, { useState, useEffect, useContext } from "react"
import { Link, NavLink, useNavigate } from 'react-router-dom';
import MonthPickerComponent from '../../Utils/MonthPickerComponent'
import { TableDownloadContext } from '../../Contexts/TableDownloadContext'
import moment from "moment"
import line from "../../images/line.png"
import xls from "../../images/xls/png/Group 47.png"
import FileIcon from "../../images/file.png"
import FileIconBlur from "../../images/fileblur.png"
import ExcelPopup from "../ExcelPopup";
import '../MainMenu.css'
import { useLocation } from "react-router-dom";
import { routeNames } from "../../routeSegments";
import Switch from './DetailsPage/CFSFinancial/ToggleSwitch'
import ToggleButton from "../RefineSearchComponents/ToggleSwitch";

import ExportPopup from "../ExportPopup/CFSExport";
import { cfsExcelExportData, data, limitedPartnerProfileExportData, limitedPartnerexitExportData } from "../ExportPopup/ExportData"
import { cfsExcelExport, exportLPExcel } from "../../Config/config";
import { TableDataContext } from '../../Contexts/TableDataContext'
import PdfDownloader from "../shared/PdfDownloader";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import Constants from "../../Constants";
import { UserContext } from "../../Contexts/UserContext";
import { FaFilter } from "react-icons/fa";
import { IoClose  } from "react-icons/io5";
import { Tooltip } from "antd";
import { RiMailDownloadLine } from "react-icons/ri";
import SavedFilterContent from "../SavedFilter";
import DownloadTrigger from "../ExportPopup/DownloadTrigger";

/**
 * The MainMenu function is a React component that renders a menu with various options and buttons,
 * including a switch for currency, a download button for exporting data to Excel, and a button for
 * downloading PDF files.
 * @param props - An object containing the properties passed to the MainMenu component.
 * @returns The MainMenu component is returning a JSX element.
 */
function MainMenu(props) {
    const { handleDownloadExcel } = useContext(TableDownloadContext)
    const {totalNoOfCompanies, setTotalNoOfCompanies,tableCompanyId,currency, setCurrency, globalSearchResult, totalNoOfCompaniesWithFin } = useContext(TableDataContext);
    const { monthPickerValue, refineSearchFilters,groupId, isMobile,setOpen,open,setIsMobile,setSave,save } = useContext(PeFilterContext);
    
    const [openTab, setOpenTab] = React.useState(1);
    const [showPopup, setShowPopup] = useState(false);
    const [date, setDate] = useState([
        moment().startOf("month").subtract(12, "months").format("YYYY-MM-DD"),
        moment().endOf("month").format("YYYY-MM-DD"),
      ]);
    useEffect(() => {
        setOpenTab(props.active)
    }, [openTab])

    const {isStudent, isTrialExport} = useContext(UserContext)
    const location  = useLocation();
    const pathname = location.pathname.endsWith('/all')? location.pathname.substring(0, location.pathname.lastIndexOf('/')): location.pathname;
console.log(pathname, "pathname in main menu")
    const download = () => {
        handleDownloadExcel()
    }
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const handleToggle = (isOn) => {
        setCurrency(isOn=='and' ? 'USD' :'INR')
      };
      useEffect(()=>{
        if (window.innerWidth < 800) {
            // setOpen(true);
            setIsMobile(true);
        }    },[])

      const savedList = () => {
    setSave(!save);
  };

  // Helper function to check if filters have any meaningful values
const hasActiveFilters = (filters) => {
    if (!filters || Object.keys(filters).length === 0) {
        return false;
    }
    
    return Object.entries(filters).some(([key, value]) => {
        // Skip the 'operator' field as it's not a filter value
        if (key === 'operator') {
            return false;
        }
        
        // Check for non-empty arrays
        if (Array.isArray(value)) {
            return value.length > 0;
        }
        
        // Check for non-null, non-undefined, non-empty string values
        return value !== null && value !== undefined && value !== "";
    });
};


  console.log(refineSearchFilters[pathname],"ititi",isFromGlobalSearch(),Object.keys(refineSearchFilters[pathname] || {}).length === 0 )
    return (
        <div className="pt-0 pl-3 md:pr-4 pr-3">
            <div className="scrollbar rounded">
                <div className="py-2 px-5 items-center rounded-b-none bg-[#FFFFFF] block lg:flex flex-row justify-between shadow-[0_2px_6px_0_rgba(0,0,0,0.08)]">
                    {props.menu === "cfs" || props.menu === "ioc" ? (
                        <div className="flex flex-row space-x-5">
                            <div className="text-[14pt] lg:text-[16px] leading-[14px] font-sans_book_body text-[#666666]">
                                {(props.menu === "cfs" || props.menu === "ioc") && (
                                    <div className="flex flex-col space-y-2">
                                        
                                            <div className="flex flex-row space-x-5">
                                                <div className="text-[14pt] lg:text-[16px] leading-[14px] font-sans_book_body text-[#666666]">
                                                    Total no. of companies: {isFromGlobalSearch() ? globalSearchResult?.cfs_company?.length : totalNoOfCompaniesWithFin?.toLocaleString("en-IN")}
                                                </div>
                                            </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : null}

                    <div className="flex justify-between py-2 lg:py-0 space-x-2 items-center">
                        {props.menu !== "ioc" && (
                            <div className="pt-[.5rem] md:pt-0 lg:pt-0">
                                <Switch />
                                {/* <ToggleButton onLabel="USD" offLabel="INR" onToggle={handleToggle} /> */}
                            </div>
                        )}
                        
                        <div className="flex justify-between items-center space-x-2">
                            {isMobile && (
                                <>
                                    {/* <button
                                        className="cursor-pointer lg:ml-7 ml-4"
                                        onClick={() => setOpen(!open)}
                                    >
                                        <FaFilter color="#bc8b20" size={21} />
                                    </button> */}
                                    <a>
                                        <img
                                            className="h-[24px] max-w-[2px] mt-1"
                                            src={line}
                                            alt="Separator"
                                        />
                                    </a>
                                </>
                            )}

                            <span>
                                {isStudent === 'true' ? null : (
                                    <DownloadTrigger onClick={() => setShowPopup(!showPopup)} />
                                )}

                                {showPopup && (
                                    <ExportPopup
                                        url={cfsExcelExport}
                                        fileName={Constants.exportNames.cfs_list}
                                        onClose={() => setShowPopup(false)}
                                        exportOptions={cfsExcelExportData}
                                    />
                                )}
                            </span>
                           
                            </div>
                           
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MainMenu